import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { sendChatMessage } from '../service/ChatService';
import './ChatWidget.scss';

const ChatWidget = () => {
    const [open, setOpen] = useState(false);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState([
        { from: 'bot', text: '¡Hola! ¿En qué puedo ayudarte?' }
    ]);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        if (open) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages, open]);

    const enviarMensaje = async () => {
        const texto = input.trim();
        if (!texto || loading) return;

        const historial = messages;
        setMessages((prev) => [...prev, { from: 'user', text: texto }]);
        setInput('');
        setLoading(true);

        const respuesta = await sendChatMessage(texto, historial);

        setMessages((prev) => [...prev, { from: 'bot', text: respuesta }]);
        setLoading(false);
    };

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            enviarMensaje();
        }
    };

    return (
        <>
            {open && (
                <div className="chat-widget-panel">
                    <div className="chat-widget-header">
                        <span>Asistente virtual</span>
                        <Button icon="pi pi-times" className="p-button-rounded p-button-text p-button-sm" onClick={() => setOpen(false)} />
                    </div>

                    <div className="chat-widget-messages">
                        {messages.map((msg, idx) => (
                            <div key={idx} className={`chat-widget-message ${msg.from}`}>
                                {msg.text}
                            </div>
                        ))}
                        {loading && <div className="chat-widget-typing">Escribiendo...</div>}
                        <div ref={messagesEndRef} />
                    </div>

                    <div className="chat-widget-input">
                        <InputText value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={onKeyDown} placeholder="Escribí tu consulta..." disabled={loading} />
                        <Button icon="pi pi-send" onClick={enviarMensaje} disabled={loading || !input.trim()} />
                    </div>
                </div>
            )}

            <Button
                icon={open ? 'pi pi-times' : 'pi pi-comments'}
                className="chat-widget-button p-button-rounded"
                onClick={() => setOpen((prev) => !prev)}
            />
        </>
    );
};

export default ChatWidget;
